import React, { Component } from 'react';
import { Card, CardBody, CardSubtitle, CardLink, Button, CardHeader, Modal, ModalHeader, ModalBody, Col, Row, Badge } from 'reactstrap'
import Fetch from '../../Auxiliares/fetch'
import ModDoc from '../../Paginas/Admin/modDoc'

export default class docCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isDelModalOpen: null,
            isModModalOpen: null
        }

        this.toggleDel = this.toggleDel.bind(this)
        this.toggleMod = this.toggleMod.bind(this)
    }

    toggleDel(obj) {
        this.setState({
            isDelModalOpen: obj ? obj : null
        })
    }

    toggleMod(obj) {
        this.setState({
            isModModalOpen: obj ? obj : null
        })
    }

    eliminar = (id) => {
        Fetch('/api/deleteDoc', {
            method: 'DELETE',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id })
        })
            .then(response => {
                this.props.actualizar();
                this.toggleDel();
            })
            .catch(err => {
                switch (err.status) {
                    case 600:
                        console.log('Error inesperado')
                        break;
                    case 602:
                        console.log('Este elemento no existe')
                        break;

                    default:
                        break;
                }
            })
    }


    render() {
        return (
            <div>
                <Card>
                    <CardHeader>
                        <Row>
                            <Col className="col-9 align-self-center">{this.props.doc}</Col>
                            <Col className="col-1"><Button className="btn-danger text-right" onClick={() => { this.toggleDel(this.props) }}>X</Button></Col>
                        </Row>
                    </CardHeader>

                    <CardBody onClick={() => { this.toggleMod(this.props) }} className="clicable">
                        <CardSubtitle className="mb-3"><div className="font-weight-bold d-inline">Resolución: </div><Badge color="info">{this.props.ppp} dpi</Badge></CardSubtitle>
                        <CardSubtitle className="mb-3"><div className="font-weight-bold d-inline">Tipo de documento: </div>{this.props.doble_cara ? <div>Doble cara</div> : <div>Una cara</div>}</CardSubtitle>
                    </CardBody>
                </Card>

                <Modal isOpen={this.state.isDelModalOpen !== null} toggle={() => this.toggleDel()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleDel()}>Eliminar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 text-center">
                                    ¿Esta seguro de que desea eliminar este elemento?
                                    <div className="font-weight-bold">
                                        {this.props.doc}
                                    </div>
                                    <CardBody>
                                        <CardLink><Button className="btn-danger" onClick={() => this.eliminar(this.state.isDelModalOpen.id)}>Aceptar</Button></CardLink>
                                        <CardLink><Button className="btn-light" onClick={() => this.toggleDel()}>Cancelar</Button></CardLink>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>

                <Modal isOpen={this.state.isModModalOpen !== null} toggle={() => this.toggleMod()}
                    className="modal-md">
                    <ModalHeader toggle={() => this.toggleMod()}>Modificar</ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col>
                                <Card className="p-3 border-0">
                                    <div>
                                        <ModDoc id={this.props.id} doc={this.props.doc} ppp={this.props.ppp} doble_cara={this.props.doble_cara} switch={this.props.switch} cerrar={() => this.toggleMod()} actualizar={this.props.actualizar} />
                                    </div>
                                </Card>
                            </Col>

                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        )
    }
}